import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Box, Button, Flex } from "@chakra-ui/react";

import { Form, Formik } from "formik";
import { FocusError } from "../../../components/FocusError";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { AnexosCadastrar } from "./Cadastrar";
import CriancaService from "../../../../main/services/CriancaService";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
} from "../../../../helpers/Funcionalidades";
import { VisualizarPageAnexos } from "./Visualizar";
import { isAfter, isValid, parse, intervalToDuration } from "date-fns";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../utils/hasFormChanged";
import { handleVerify } from "../../../utils/handleVerify";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";

const suportedFormats = [
  ".png",
  ".bmp",
  ".tiff",
  ".jpg",
  ".jpeg",
  ".doc",
  ".docx",
  ".txt",
  ".dot",
  ".pdf",
  ".xml",
  ".xls",
  ".xlam",
  ".ods",
];

const suportedFormatsVideo = [
  ".avi",
  ".mp4",
  ".m4v",
  ".mov",
  ".mpg",
  ".mpeg",
  ".wmv",
  ".flv",
  ".mkv",
  ".webm",
  ".3gp",
  ".ogv",
];

const schema = Yup.object().shape({
  dataDocumento: Yup.string("Este campo é obrigatório!")
    .nullable()
    .required("Este campo é obrigatório!")
    .test("validDate", "Data inválida!", (value) => {
      if (!!value) {
        if (value.length === 10) {
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    .test(
      "dataNascimentoAfterToday",
      "A data informada não pode ser uma data futura!",
      (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      }
    ),
  tipoAnexo: Yup.object().nullable().required("Este campo é obrigatório!"),
  observacao: Yup.string()
    .trim()
    .when("tipoAnexo.id", {
      is: (idDescricao) => idDescricao === 25 || idDescricao === 29,
      then: Yup.string().required("Este campo é obrigatório!"),
      otherwise: Yup.string(),
    }),
  anexo: Yup.mixed()
    .required("Este campo é obrigatório!")
    .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
      if (value === null) {
        return true;
      } else {
        return value.size <= 10000000;
      }
    })
    .test("fileType", "Anexar uma extensão válida.", function (value) {
      const { tipoAnexo } = this.parent;

      if (value && value.path) {
        let haveFormat = false;
        if (tipoAnexo?.descricao === "Vídeo da Criança ou Adolescente") {
          suportedFormatsVideo.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
        } else {
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
        }
        return haveFormat;
      } else {
        return true;
      }
    }),
});

export const VisualizarAnexosCrianca = ({
  setLoadingPainel,
  dataNascimento,
}) => {
  const { id } = useParams();
  const [isTrueVisualizar, setIsTrueVisualizar] = useState(true);
  const history = useHistory();
  const url = window.location.href;
  const {
    setEditarOcorCrianca,
    setCadastrarOcorCrianca,
    cadastrarOcorrencia,
    setCadastrarOcorrencia,
    atualizarOcorrencia,
    setAtualizarOcorrencia,
    setEditarCriancaCr,
    setAnexarCrianca,
    setEditarAnexoCrianca,
    idPJ,
  } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const idade16 = dataNascimento
    ? intervalToDuration({
        start: new Date(dataNascimento),
        end: new Date(),
      }).years >= 16
    : false;
  const [initialValues, setInitialValues] = useState({
    tipoAnexo: "",
    dataDocumento: "",
    idAnexo: "",
    obersevacao: "",
    anexo: null,

    categoriaSearch: "",
    tipoSearch: "",
    ordemSearch: "",
    dataSearch1: "",
    dataSearch2: "",
  });

  useEffect(() => {
    setEditarCriancaCr(false);
  }, [setEditarCriancaCr]);

  useEffect(() => {
    if (url.includes("visualizar")) {
      setIsTrueVisualizar(true);
      setInitialValues({
        tipoAnexo: "",
        dataDocumento: "",
        idAnexo: "",
        obersevacao: "",
        anexo: null,

        categoriaSearch: "",
        tipoSearch: "",
        ordemSearch: { id: 1, descricao: "Mais Recente" },
        dataSearch1: "",
        dataSearch2: "",
      });
      setCadastrarOcorCrianca(false);
      setEditarOcorCrianca(false);
      setAnexarCrianca(false);
      setEditarAnexoCrianca(false);
    }
  }, [
    url,
    setCadastrarOcorCrianca,
    setEditarOcorCrianca,
    setAnexarCrianca,
    setEditarAnexoCrianca,
  ]);

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  useEffect(() => {
    if (atualizarOcorrencia) {
      Swal.fire({
        title: "Sucesso!",
        text: "Arquivo anexado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setAtualizarOcorrencia(false);
      });
    } else if (cadastrarOcorrencia) {
      Swal.fire({
        title: "Sucesso!",
        text: "Arquivo anexado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setCadastrarOcorrencia(false);
      });
    }
  }, [
    atualizarOcorrencia,
    setAtualizarOcorrencia,
    cadastrarOcorrencia,
    setCadastrarOcorrencia,
  ]);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { dataDocumento, tipoAnexo, observacao, anexo, idAnexo } = values;

      const dataDocumentoObj = parse(dataDocumento, "dd/MM/yyyy", new Date());

      const horaAtual = new Date();
      const diferencaFusoHorario = dataDocumentoObj.getTimezoneOffset() / 60;
      dataDocumentoObj.setHours(
        horaAtual.getHours() - diferencaFusoHorario,
        horaAtual.getMinutes(),
        horaAtual.getSeconds()
      );

      const valuesToSend = {
        dataDocumento: dataDocumento ? dataDocumentoObj.toISOString() : "",
        idTipo: tipoAnexo.id ? tipoAnexo.id : "",
        observacao: observacao ? observacao : "",
        anexo: anexo ? anexo : null,
      };

      if (url.includes("editar")) {
        CriancaService.getPutAnexoCrianca(idAnexo, valuesToSend)
          .then((res) => {
            setIsTrueVisualizar(!isTrueVisualizar);
            setEditarOcorCrianca(false);
            setCadastrarOcorCrianca(false);
            history.push(`/crianca/visualizar-anexos/${id}`);
            setAtualizarOcorrencia(true);
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      } else if (url.includes("cadastrar")) {
        CriancaService.getPostAnexoCrianca(id, valuesToSend)
          .then((res) => {
            setIsTrueVisualizar(true);
            setEditarOcorCrianca(false);
            setCadastrarOcorCrianca(false);
            history.push(`/crianca/visualizar-anexos/${id}`);
            setCadastrarOcorrencia(true);
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }

      actions.setSubmitting(false);
    });
  };

  return roleKeycloack &&
    !roleKeycloack.includes(criancaFunc.visualizarTudoDefensoria) ? (
    <>
      <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {(props) => (
              <Form onKeyDown={onKeyDown}>
                {url.includes("editar") &&
                  setEditarOcorCrianca(
                    hasFormChanged(initialValues, props.values)
                  )}

                <FocusError />
                {url.includes("visualizar") ? (
                  <VisualizarPageAnexos
                    id={id}
                    setIsTrueVisualizar={setIsTrueVisualizar}
                    props={props}
                    setInitialValues={setInitialValues}
                    setLoadingPainel={setLoadingPainel}
                    idade16={idade16}
                  />
                ) : (
                  <AnexosCadastrar
                    initialValues={initialValues}
                    valuesProps={props.values}
                    setInitialValues={setInitialValues}
                    idade16={idade16}
                    roleKeycloack={roleKeycloack}
                    user={user}
                  />
                )}

                <Flex justifyContent="flex-end" gap={4}>
                  {(url.includes("cadastrar") || url.includes("editar")) && (
                    <Button
                      mt="30px"
                      px="45px"
                      h="42px"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      onClick={() =>
                        history.push(`/crianca/visualizar-anexos/${id}`)
                      }
                      _hover={{ bg: "#169499" }}
                    >
                      {"Cancelar"}
                    </Button>
                  )}

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      url.includes("cadastrar")
                        ? ocorrenciasFunc.incluir
                        : url.includes("editar")
                        ? ocorrenciasFunc.alterar
                        : ""
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    {(url.includes("cadastrar") || url.includes("editar")) &&
                    props.values.tipoAnexo &&
                    handleVerify(props.values) ? (
                      <Button
                        type="submit"
                        translate="no"
                        mt="30px"
                        px="45px"
                        h="42px"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        _hover={{ bg: "#169499" }}
                        isLoading={props.isSubmitting}
                      >
                        {"Salvar"}
                      </Button>
                    ) : (
                      ""
                    )}
                  </Permission>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
    </>
  ) : (
    <Box mt="4">
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
